export default function rastreio(to, from, next) {
  const query = to.fullPath.split('/')[1]
  if(!to.fullPath.includes('rastreio')) {
    return next(`/rastreio${query}`)
  } else if(to.fullPath === '/rastreio') {
    window.location.href = "https://soudealgodao.com.br/souabr/"
  }
  return next()
}